function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      transition: transform 200ms ease-in-out;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  will-change: transform;\n  transform-origin: right;\n\n  &:before {\n    background-color: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n    min-height: ", "px;\n\n    &:before {\n      content: '';\n      display: block;\n      border-radius: ", "px;\n      background-color: ", ";\n      height: ", "px;\n      width: ", "px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: none;\n  appearance: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  &:focus {\n    ", ";\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { InlineChildren, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { MINIMUM_CLICKABLE_HEIGHT } from './constants';
export var PaginationIndicator = styled.button(_templateObject(), getFocusStyles(), function (props) {
  return css(_templateObject2(), props.size.height * 4, MINIMUM_CLICKABLE_HEIGHT, props.borderRadius, props.color.unselected, props.size.height, props.size.width);
});
export var SelectedIndicator = styled(PaginationIndicator).attrs({
  style: function style(props) {
    var index = props.selectedIndex;
    return {
      transform: "translateX(".concat(index * props.size.width + index * props.size.spacing, "px)")
    };
  }
})(_templateObject3(), function (props) {
  return props.color.selected;
}, function (props) {
  return props.shouldTransition && css(_templateObject4());
});
export var PaginationIndicators = styled(InlineChildren)(_templateObject5());
export var PaginationContainer = styled.div(_templateObject6());
export var Root = styled.div(_templateObject7());